import axios from "axios";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      sessionStorage.setItem(
        "redirectAfterLogin",
        window.location.pathname + window.location.search
      );
      window.location.href = "/login";
    } else {
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
